import { DropDownList, DropDownListChangeEvent, ListItemProps } from "@progress/kendo-react-dropdowns";
import { GridCellProps } from "@progress/kendo-react-grid";
import { useGetEmployesQuery } from "../../../redux/api/cache";
import { Magasin } from "../../../models/Magasin";
import { dateToBdFormat } from "../../../commons/helpers/Dates";
import { Agence } from "../../../models/Agence";
import React from "react";
import { Chip } from "@progress/kendo-react-buttons";
import "./usercell.css";
import { clone } from "../../../commons/helpers/ObjectHelper";
import { Employe } from "../../../models/Employe";

interface UserCellProps {
    gridCellProps: GridCellProps;
    magasin: Magasin;
    date: Date;
    agence: Agence;
}

export const UserCell = (props: UserCellProps) => {
    const aucunText = "(Aucun)";
    const { dataItem } = props.gridCellProps;
    const field = props.gridCellProps.field || '';
    const dataValue = dataItem[field] === null ? '' : dataItem[field];
    const { data: employes = [] } = useGetEmployesQuery({ agence: props.agence.agence_cd, mag_num: props.magasin.mag_num, date: dateToBdFormat(props.date) }, { skip: props.magasin.mag_num === -1 || !props.agence.agence_cd, refetchOnMountOrArgChange: true });

    const handleChange = (e: DropDownListChangeEvent) => {
        if (props.gridCellProps.onChange) {
            props.gridCellProps.onChange({
                dataIndex: 0,
                dataItem: props.gridCellProps.dataItem,
                field: props.gridCellProps.field,
                syntheticEvent: e.syntheticEvent,
                value: e.value === aucunText ? 0 : e.value.numeroEmploye
            });
        }
    }

    const getCurrentValue = () => {
        let currentEmploye = employes.find(e => e.numeroEmploye === dataValue);
        return currentEmploye ? `${currentEmploye.nom} (${currentEmploye.numeroEmploye})` : "";
    };

    const CustomItemRender = (
        li: React.ReactElement<HTMLLIElement>,
        itemProps: ListItemProps
    ) => {
        const itemChildren = (
            <>
                {itemProps.dataItem.nom !== aucunText ? <div className="usercell-grid">
                    <span>
                        {`${itemProps.dataItem.nom} (${itemProps.dataItem.numeroEmploye})`}
                    </span>
                    <Chip
                        text={itemProps.dataItem.statut}
                        value="chip"
                        disabled={true}
                        className="usercell-chip"
                        style={{ backgroundColor: itemProps.dataItem.statut === "Disponible" ? '#48f777' : '#e4e7eb' }}
                    />
                </div> : <span>{aucunText}</span>}
            </>
        );

        return React.cloneElement(li, li.props, itemChildren);
    };


    const sortedEmployes = (): Employe[] => {
        const tempEmployes = clone(employes) as Employe[];
        tempEmployes.sort((a: Employe, b: Employe) => {
            if (a.statut === "Disponible")
                return -1;

            if (b.statut === "Disponible")
                return 1;

            const nameA = a.nom.toUpperCase();
            const nameB = b.nom.toUpperCase();

            if (nameA < nameB)
                return -1;
            else if (nameA > nameB)
                return 1;
            else
                return 0;
        });

        return tempEmployes;
    }

    return (
        <td>
            {dataItem.inEdit ? (
                <DropDownList
                    onChange={handleChange}
                    value={getCurrentValue()}
                    itemRender={CustomItemRender}
                    data={[{
                        numeroEmploye: 0,
                        nom: aucunText,
                        statut: "",
                        raisonAbsence: ""
                    }, ...sortedEmployes()]}
                />
            ) : (
                getCurrentValue()
            )}
        </td>
    );
}